import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { LoadingButton } from '@mui/lab';
import { TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { sendServerRequest } from '../../server/request';
import { openGlobalSnack } from '../utils/snack';
import { CircularLoading } from '../utils/loading';

type ManutationPanelProps = {
  // base das rotas, ex: '/server/fgtsCommand/botManutation'
  endpointBase: string;
  // nome do sistema exibido nas confirmações, ex: 'FGTS', 'CLT', 'Max'
  systemLabel: string;
  // exibe o botão de disparo de "manutenção off"
  showShot?: boolean;
  // mantém o botão de disparo desabilitado
  shotDisabled?: boolean;
};

export default function ManutationPanel({
  endpointBase,
  systemLabel,
  showShot = false,
  shotDisabled = false,
}: ManutationPanelProps) {
  const [cState, setCState] = useState(false);
  const [serverState, setServerState] = useState(false);
  const [message, setMessage] = useState('');
  const [serverMessage, setServerMessage] = useState('');
  const [loadingGetManutation, setLoadingGetManutation] = useState(true);
  const [loadingUpdateManutation, setLoadingUpdateManutation] = useState(false);
  const [loadingUpdateMessage, setLoadingUpdateMessage] = useState(false);
  const [isShotting, setIsShotting] = useState(false);

  useEffect(() => {
    if (!loadingGetManutation) return;
    getManutation();
  }, [loadingGetManutation]);

  useEffect(() => {
    if (!loadingUpdateManutation) return;
    sendServerRequest(`POST`, `${endpointBase}/setManutationStatus`, {
      newStatus: cState,
    }).then(() => {
      setLoadingUpdateManutation(false);
      setLoadingGetManutation(true);
    }).catch(() => {
      setLoadingUpdateManutation(false);
      openGlobalSnack('Atualize a página', 'error');
    });
  }, [loadingUpdateManutation]);

  useEffect(() => {
    if (!loadingUpdateMessage) return;
    sendServerRequest(`POST`, `${endpointBase}/setManutationMessage`, {
      message,
    }).then(() => {
      setLoadingUpdateMessage(false);
      openGlobalSnack('Mensagem atualizada com sucesso.', 'success');
      setLoadingGetManutation(true);
    }).catch(() => {
      setLoadingUpdateMessage(false);
      openGlobalSnack('Não foi possível atualizar a mensagem.', 'error');
    });
  }, [loadingUpdateMessage]);

  useEffect(() => {
    if (!isShotting) return;
    shot();
  }, [isShotting]);

  return (
    <>
      {loadingGetManutation ? <CircularLoading /> : <div style={{ textAlign: 'center' }}>
        <FormControlLabel control={<Switch disabled={isShotting} readOnly={isShotting} checked={cState} onChange={(e) => {
          setCState(e.target.checked);
        }} />} label="Em Manutenção" />
        <p style={{ fontSize: '12px', color: '#000000a0', marginTop: '0px', marginBottom: '8px' }}>Se essa opção estiver ativada, o sistema irá parar.</p>
        <div>
          <LoadingButton loading={loadingUpdateManutation} onClick={() => {
            let isok = true;
            if (cState) {
              isok = window.confirm(`Isso irá parar a operação de ${systemLabel}, tem certeza de deseja continuar?`);
            }
            if (isok) {
              setLoadingUpdateManutation(true);
            }
          }} variant='contained' disabled={cState == serverState || isShotting}>Atualizar Estado</LoadingButton>
          {showShot && <div style={{ marginTop: '10px' }}>
            <LoadingButton loading={isShotting} disabled={shotDisabled || cState || serverState} variant='contained'
              onClick={() => {
                let isok = window.confirm("Isso irá avisar os clientes que o sistema voltou, tem certeza de deseja continuar?");
                if (!isok) return;
                setIsShotting(true);
              }}
            >Disparar Manutenção Off</LoadingButton>
          </div>}
        </div>

        <div style={{ marginTop: '24px', maxWidth: '520px', marginLeft: 'auto', marginRight: 'auto' }}>
          <TextField
            label="Mensagem de manutenção"
            multiline
            minRows={3}
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <p style={{ fontSize: '12px', color: '#000000a0', marginTop: '4px', marginBottom: '8px' }}>Mensagem enviada ao cliente quando o sistema está em manutenção.</p>
          <LoadingButton loading={loadingUpdateMessage} onClick={() => {
            if (!message.trim()) {
              openGlobalSnack('A mensagem não pode estar vazia.', 'error');
              return;
            }
            setLoadingUpdateMessage(true);
          }} variant='contained' disabled={message == serverMessage || isShotting}>Atualizar Mensagem</LoadingButton>
        </div>
      </div>}
    </>
  );

  function getManutation() {
    sendServerRequest('GET', `${endpointBase}/isManutation`).then((e) => {
      setCState(e.data.data.isManutation);
      setServerState(e.data.data.isManutation);
      const msg = e.data.data.manutationMessage ?? '';
      setMessage(msg);
      setServerMessage(msg);
      setLoadingGetManutation(false);
    }).catch(() => {
      openGlobalSnack('Atualize a página', 'error');
    });
  }

  function shot() {
    sendServerRequest('POST', `${endpointBase}/manutationOffShot`).then((e) => {
      openGlobalSnack(`Aviso completado com sucesso. Contato(s): ${e.data.data.shoted}`, 'success');
      setIsShotting(false);
    }).catch(() => {
      setIsShotting(false);
      openGlobalSnack('Atualize a página', 'error');
    });
  }
}
